<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index/exinfo/exhibition-info">展会</BreadcrumbItem>
          <BreadcrumbItem>云展台管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/contact-exhibition')">
          <span class="htb-add">+</span>
          <span>绑定展会</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="addcase">
        <div class="f-tar" style="padding: 20px;">
          <Button @click="$router.push('/exhibition/index/exinfo/exhibition-info')">返回</Button>
        </div>
        <div class="addcase-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form
                ref="formInline"
                :model="formInline"
                :rules="ruleInline"
                label-position="right"
                :label-width="150"
                @submit.native.prevent
              >
                <FormItem label="展会名称：" prop="name">
                  <Input v-model="formInline.name" disabled />
                </FormItem>
                <FormItem label="展会时间：" prop="time">
                  <Input v-model="formInline.time" disabled />
                </FormItem>
                <FormItem label="所在展馆：" prop="type">
                  <Select v-model="formInline.hall" filterable placeholder="所在展馆" disabled>
                    <Option
                      v-for="item in exHallArr"
                      :value="item.name"
                      :key="item.name"
                    >{{ item.name }} - {{item.value}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="展品类别：" prop="type">
                  <Select
                    v-model="formInline.type"
                    filterable
                    placeholder="展品类别"
                    multiple
                    @on-change="selectChange"
                  >
                    <Option
                      v-for="item in exTypeArr"
                      :value="item.name"
                      :key="item.name"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="展位号：" prop="num">
                  <Input type="text" v-model="formInline.num" placeholder="请输入展位号" />
                </FormItem> 

                <Row v-for="(booth, index) in formInline.boothInfo" :key="'boothInfo-' + index">
                  <Col span="11">
                    <FormItem label="展馆编号：" prop="time">
                      <Input v-model="booth.Hall" />
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem label="展位编号：" prop="time">
                      <Input v-model="booth.Code" />
                    </FormItem>
                  </Col>
                  <Col span="2" class="ie-icon">
                    <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addBootArr()" />
                    <Icon
                      type="ios-remove-circle-outline"
                      v-else
                      style="color: red;"
                      @click="delBootArr(index)"
                    />
                  </Col>
                </Row>
                
                <FormItem label="展位面积：" prop="name">
                  <InputNumber :max="10" :min="1" v-model="formInline.area"></InputNumber> 单位：m²
                </FormItem>
                <br />
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    @click="handleSubmit('formInline')"
                    :loading="loading"
                  >确定</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
export default {
  name: "add-case",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      joinInfo: null,
      formInline: {
        // form双向绑定
        type: [],
        hall: null,
        num: "",
        time: "",
        area: 0,
        boothInfo: [{ Hall: "", Code: "" }]
      },
      ruleInline: {
        num: [{ required: true, message: "展位号不能为空", trigger: "blur" }]
      },
      exTypeArr: [], // 展商类别
      exHallArr: [], // 展商类别
      categories: []
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      getJoinExhibitionInfoByCompId:
        "exhibitionModule/getJoinExhibitionInfoByCompId",

      getJoinById: "exhibitionModule/getJoinById",
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo"
    }),
    addBootArr() {
      this.formInline.boothInfo.push({ Hall: "", Code: "" });
    },
    delBootArr(i) {
      this.formInline.boothInfo.splice(i, 1);
    },
    async init() {
      this.joinInfo = await this.getJoinById(this.query.id);
      if (this.joinInfo) {
        let ex = this.joinInfo.exInfo ? JSON.parse(this.joinInfo.exInfo) : "";
        this.formInline.name = ex.Name;
        // this.formInline.num = this.joinInfo.boothCode || "";
        this.formInline.area = this.joinInfo.boothArea || 0;

        let boothInfo = this.joinInfo.boothInfo;
        this.formInline.boothInfo =
          boothInfo && boothInfo.indexOf("[") !== -1
            ? JSON.parse(boothInfo)
            : [{ Hall: "", Code: "" }];
        this.formInline.time = `${moment(ex.StartTime).format(
          "YYYY/MM/DD"
        )}~${moment(ex.EndTime).format("YYYY/MM/DD")}`;
      }
      let hallData = await this.getHallByExhibition(this.joinInfo.exhibitionId);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }
      let categoryData = await this.getCategoryByExhibition(
        this.joinInfo.exhibitionId
      );
      if (categoryData && categoryData.length) {
        this.exTypeArr = categoryData;
      } else {
        this.exTypeArr = [];
      }
      if (
        (this.exHallArr && this.exHallArr.length) ||
        (this.exTypeArr && this.exTypeArr.length)
      ) {
        this.getInfo();
      } else {
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
      }
    },
    async getInfo() {
      // 通过公司和展会id获取参展信息
      let data = await this.getJoinExhibitionInfoByCompId({
        compId: this.company.id,
        exhibitionId: this.joinInfo.exhibitionId
      });
      data.categories = data.categories ? JSON.parse(data.categories) : [];
      data.compInfo = data.compInfo ? JSON.parse(data.compInfo) : null;
      data.exInfo = data.exInfo ? JSON.parse(data.exInfo) : null;
      if (
        data.categories &&
        data.categories.length &&
        this.exTypeArr &&
        this.exTypeArr.length
      ) {
        this.formInline.type = [];
        this.exTypeArr.forEach(v => {
          data.categories.forEach(c => {
            if (c.Value === v.name) {
              this.formInline.type.push(v.name);
            }
          });
        });
      }
      if (data.exHall) {
        this.formInline.hall = data.exHall;
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!this.formInline.hall) {
        this.$Message.error("展馆信息不能为空！");
      }
      this.categories = [];
      this.exTypeArr.forEach(v => {
        this.formInline.type.forEach((c, index) => {
          if (c === v.name && index <= 2) {
            this.categories.push({ Id: v.id, Value: v.name });
          }
        });
      });
      if (!this.formInline.hall) {
        this.$Message.error("展馆信息不能为空！");
        return;
      }
      if (this.categories && this.categories.length === 0) {
        this.$Message.error("产品类别不能为空！");
        return;
      }

    }, 
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.$emit("close");
    },
    selectChange(e) {
      if (e && e.length > 3) {
        this.formInline.type = [e[0], e[1], e[2]];
      }
    }
  }
};
</script>
 
<style lang="scss" scoped>
.ie-icon {
  line-height: 31px;
  padding-left: 30px;
  .ivu-icon {
    font-size: 22px;
    cursor: pointer;
    font-size: 22px;
    color: #118eea;
  }
  &.z-remove {
    color: #d71f06;
  }
}
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 900px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>